import Sprite from './Sprite';

var TextureCache = {};

/**
 * @description Спрайт, кадры которого создаются из атласного конфига
 * @memberOf module:display
 * @augments module:display.Sprite
 * @example let view = new AtlasSprite(APP.library.getAsset("items"), itemsAtlas, "weapons/sword/1");
 */
class AtlasSprite extends Sprite {

    /**
     * @param assets ассет(ы) изображения
     * @param atlases конфиг(и) атласа
     * @param path путь к кадру(ам)
     */
    constructor(assets, atlases, path) {
        super();

        this.textures = AtlasSprite.getFrames(assets, atlases, path);
        this.texture = this.textures[0];

        if(this.totalFrames > 1) this.gotoAndPlay(0);
        else this.gotoAndStop(0);
    }

    /**
     * Получение списка кадров. На выходе возвращает массив объектов вида {x: 0, y: 0: width: 100, height: 100}. Удобно оверрадить для поддержки любых сторонних форматов атласов.
     * @param atlas конфиг(и) атласа
     * @param path путь к кадру(ам)
     * @returns {Array}
     */
    static getFramesInfo(atlas, path) {
        let configs = [];

        let scale = atlas.meta.scale ? atlas.meta.scale*1 : 1;

        let frameKeys = Object.keys(atlas.frames);

        for (let name of frameKeys) {
            if (name.substr(0, path.length) == path) {
                configs.push({name: name, frame: atlas.frames[name], scale: scale});
            }
        }

        return configs;
    }

    /**
     * Получение списка текстур кадров для PIXI
     * @param assets ассет(ы) изображения
     * @param atlases конфиг(и) атласа
     * @param path путь к кадру(ам)
     * @returns {Array}
     */
    static getFrames(assets, atlases, path) {

        if(!Array.isArray(assets)) assets = [assets];
        if(!Array.isArray(atlases)) atlases = [atlases];

        let frames = [];

        for(let ix=0; ix<assets.length; ix++) {

            let asset = assets[ix];
            let atlas = atlases[ix];

            let texture = PIXI.utils.TextureCache[asset.bitmap.src].baseTexture;

            if (!texture) {
                throw Error(`Texture ${asset.bitmap.src} not found`);
            }

            let configs = AtlasSprite.getFramesInfo(atlas, path);

            for (let config of configs) {

                let name = texture.imageUrl + "_" + config.name;
                if (TextureCache[name]) {
                    frames.push(TextureCache[name]);
                }
                else {
                    let resolution = config.scale;
                    let rect = config.frame.frame;
                    let frame = null;
                    let trim = null;
                    let orig = new PIXI.Rectangle(0, 0, config.frame.sourceSize.w / resolution, config.frame.sourceSize.h / resolution);

                    if (config.frame.rotated) {
                        frame = new PIXI.Rectangle(rect.x / resolution, rect.y / resolution, rect.h / resolution, rect.w / resolution);
                    }
                    else {
                        frame = new PIXI.Rectangle(rect.x / resolution, rect.y / resolution, rect.w / resolution, rect.h / resolution);
                    }

                    if (config.frame.trimmed) {
                        trim = new PIXI.Rectangle(
                            config.frame.spriteSourceSize.x / resolution,
                            config.frame.spriteSourceSize.y / resolution,
                            config.frame.spriteSourceSize.w / resolution,
                            config.frame.spriteSourceSize.h / resolution
                        );
                    }

                    let tex = new PIXI.Texture(texture, frame, orig, trim, config.frame.rotated ? 2 : 0);
                    tex._atlasName = config.name;
                    frames.push(tex);
                    TextureCache[name] = tex;
                }
            }
        }

        return frames.length ? frames : [PIXI.Texture.EMPTY];
    }
}

export default AtlasSprite;